import { Typography } from "antd";

const { Paragraph, Title } = Typography;
const ShippingPolicy = () => {
  return (
    <div className="my-8">
      <Title level={3}>AlpShop Shipping Information</Title>
      <Paragraph className="text-left my-8 px-16 max-sm:px-4">
        <Title level={5}>What is the estimated delivery time?</Title>
        <p>
          Sellers generally procure and ship the items within the time specified
          on the product page. Business days exclude public holidays and
          Sundays. Estimated delivery time depends on the following factors:
        </p>
        <p>
          <ul>
            <li>The Seller offering the product</li>
            <li>Product’s availability with the Seller</li>
            <li>
              The destination to which you want the order shipped to and
              location of the Seller.
            </li>
          </ul>
        </p>
        <Title level={5}>
          Are there any hidden costs (sales tax, octroi etc) on items sold by
          Sellers on Alpshop?
        </Title>
        <p>
          There are NO hidden charges when you make a purchase on alpshop.in .
          List prices are final and all-inclusive. The price you see on the
          product page is exactly what you would pay. The shipping charges for
          your delivery are included in the price of your product so you will
          not need to pay extra for shipping.
        </p>
        <Title level={5}>
          Why does the estimated delivery time vary for each seller?
        </Title>
        <p>
          Delivery times are influenced by product availability, geographic
          location of the Seller, your shipping destination and the courier
          partner’s time-to-deliver in your location.
        </p>
        <Title level={5}>Refunds:</Title>
        <p>
          Cash on delivery is not allowed on the alpshop.in website. Since order
          values can be large, we do not offer COD right now.
        </p>
        <Title level={5}>What does the tag “Out of Stock” mean?</Title>
        <p>
          It simply means that currently the product is not available for sale.
        </p>
        <strong>
          Shipping for retailers is done via courier and for large volume whole
          sale orders is done through standard trucking service.
        </strong>
      </Paragraph>
    </div>
  );
};
export default ShippingPolicy;
